export default __webpack_public_path__ + "static/media/sagar-photo.03879273.jpeg";